import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { SafetyBanner } from "../components/SafetyBanner";
import { Reveal } from "../components/Reveal";
import { EMAIL, PHONE_DISPLAY, PHONE_HREF } from "../lib/site";

const QUICK_LINKS = [
  { label: "Upfront Pricing", desc: "Every service, every price — before we roll.", href: "/pricing", testid: "get-help-link-pricing" },
  { label: "Service Area", desc: "Seven zones across the Twin Cities metro.", href: "/service-area", testid: "get-help-link-service-area" },
  { label: "Reviews", desc: "5.0 stars from drivers we've rescued.", href: "/reviews", testid: "get-help-link-reviews" },
];

export default function GetHelp() {
  return (
    <main className="pt-16" data-testid="get-help-page">
      <Navbar />

      <section className="relative py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <Reveal>
            <p className="eyebrow mb-4 text-center">Get Help Now</p>
            <h1 className="font-display font-bold uppercase tracking-normal text-4xl sm:text-5xl lg:text-6xl max-w-3xl mx-auto leading-[1.02] text-center">
              <span className="block">Stranded? One call.</span>
              <span className="block">We're rolling.</span>
            </h1>
            <p className="mt-6 text-neutral-400 max-w-xl mx-auto text-base text-center">
              Jump starts, lockouts, tire changes, fuel delivery, and battery replacement — 24/7, flat rate, no surprise night or weekend fees.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:justify-center">
              <a data-testid="get-help-call-btn" href={PHONE_HREF} className="btn-primary !text-lg !px-10 !py-5">
                <Phone size={20} /> Call {PHONE_DISPLAY}
              </a>
              <a data-testid="get-help-email-btn" href={`mailto:${EMAIL}`} className="btn-ghost !text-lg !px-10 !py-5">
                <Mail size={20} /> Email Us
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-12 grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
              <div className="border border-white/10 bg-[#0D0D0D] p-6">
                <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500"><Clock size={14} /> Hours</p>
                <p className="mt-3 font-display font-semibold text-xl">24/7 — 365 days</p>
                <p className="text-sm text-neutral-400 mt-1">Nights, weekends, and holidays at the same flat rate.</p>
              </div>
              <div className="border border-white/10 bg-[#0D0D0D] p-6">
                <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500"><MapPin size={14} /> Area</p>
                <p className="mt-3 font-display font-semibold text-xl">Twin Cities Metro</p>
                <p className="text-sm text-neutral-400 mt-1">Minneapolis, St. Paul, and surrounding suburbs.</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-16 border-t border-white/10 pt-10 grid sm:grid-cols-3 gap-4">
              {QUICK_LINKS.map((l) => (
                <a key={l.href} href={l.href} data-testid={l.testid}
                  className="group border border-white/10 bg-[#0D0D0D] p-6 transition-colors duration-300 hover:border-primary/50">
                  <p className="font-display font-semibold uppercase text-lg group-hover:text-primary transition-colors duration-300">{l.label}</p>
                  <p className="text-sm text-neutral-400 mt-2">{l.desc}</p>
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <SafetyBanner />
      <Footer />
    </main>
  );
}
